import { Card, Col, Divider, Row } from "antd";
import { FunctionComponent } from "react";
import { InputNumberFormItem } from "../common/InputNumberFormItem";

export type InfosTarifProperties = {
    readOnly: boolean;
}

export const InfosTarifAdulte: FunctionComponent<InfosTarifProperties> = ({ readOnly }) => {

    return (
        <>
            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Divider orientation="left">Tarifs</Divider>
                </Col>
            </Row>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Card
                        size="small"
                        title="Tarif unique"
                        style={{ borderRadius: '8px', border: '1px solid #e8e8e8' }}
                        headStyle={{ background: '#f0f5ff', borderBottom: '1px solid #adc6ff', fontWeight: 600, color: '#1d39c4' }}
                    >
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={24} md={8}>
                                <InputNumberFormItem name="montantEtudiant" label="Etudiant" addonAfter="€" disabled={readOnly} rules={[{ required: true, message: "Veuillez saisir un montant" }]} />
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                                <InputNumberFormItem name="montantSansActivite" label="Sans activité lucrative" addonAfter="€" disabled={readOnly} rules={[{ required: true, message: "Veuillez saisir un montant" }]} />
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                                <InputNumberFormItem name="montantAvecActivite" label="Avec activité lucrative" addonAfter="€" disabled={readOnly} rules={[{ required: true, message: "Veuillez saisir un montant" }]} />
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </>
    );
}
